// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 4H8V6H16V4H20V22H4V4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M8 2H16V6H8z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 4H20V22H4V4H8M16 4V2H8V4M16 4V6H8V4","strokeWidth":"props.strokeWidth"}}]}]};

const Task1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-1',
    ref,
    icon: element,
  },
));

Task1Icon.displayName = 'Task1Icon';

export default Task1Icon;
